/**
 * CMS DOM ROUTER REQUEST POST EVENTS CALL HANDLERS
 * Version: 1.0.3
 * Based on: jquery-dom-router - v1.0.2 | Fire JavaScript based on body classes | http://jqueryboilerplate.com
 * Author: Joni Dias @ JEDEYE, LDA
 * Description: Allows DOM Routed Functions to be called after triggering a data-request on a certain element.
 * Simply attach the following to the parent element of the updating partial, considering that handler names must be used just like the dom router based classes:
 *    <div data-request-dom-handlers="dom-handler-name-a dom-handler-name-b dom-handler-name-c">demo</div>
 * Note that router function must be called with the second parameter set as "true":
 *    $(document).router({ request_func($targetEl, $triggerEl):{}, common: {} }, true)
 *
 * Note also that you must validate the $triggerEl parameter since on a page refresh triggered events, it will always be null (since no specific page element triggered an event).
 */
;(function ($) {

    if (!$.fn.findClosest) {
        $.fn.findClosest = function (selector) {
            return this.find(selector).addBack(selector);
        };
    }

    function paramToObj(name, value) {
        if (value === undefined) value = ''
        if (typeof value == 'object') return value

        try {
            return JSON.parse(JSON.stringify(eval("({" + value + "})")))
        }
        catch (e) {
            throw new Error('Error parsing the '+name+' attribute value. '+e)
        }
    }

    if (!$.fn.watch && !$.fn.unwatch) {

        /**
         * Watches an element for a change in a property
         * @param  {string}   id The property to watch
         * @param  {Function} fn The function to execute when something has changed
         */
        $.fn.watch = function (id, fn) {

            return this.each(function () {

                var self = this;

                var oldVal = self[id];
                $(self).data(
                    'watch_timer',
                    setInterval(function () {
                        if (self[id] !== oldVal) {
                            fn.call(self, id, oldVal, self[id]);
                            oldVal = self[id];
                        }
                    }, 100)
                );

            });
        };

        /**
         * Unwatches an element
         */
        $.fn.unwatch = function () {

            return this.each(function () {
                clearInterval($(this).data('watch_timer'));
            });

        };

    }

    if (!$.DOMRouter) {
        $.DOMRouter = {
            router: function (el, routes, storeRoutes) {
                var base = this,
                    storeRoutes = storeRoutes || false;

                base.$el = $(el);
                base.el = el;
                base.$el.data('DOMRouter.router', base);

                base.element = base.$el.find($.DOMRouter.defaults.element);

                base.element.addClass('dom-router-ready');

                /**
                 * Initalize the functions
                 * @return {void}
                 */
                base.init = function () {

                    /**
                     * CMS DOM ROUTER REQUEST POST EVENTS CALL HANDLERS
                     * Author: Joni Dias @ JEDEYE, LDA
                     * Description: Allows DOM Routed Functions to be called after triggering a data-request on a certain element.
                     * Simply attach the following, considering that handler names must be used just like the dom router based classes:
                     * data-request-dom-handlers="dom-handler-name-a,dom-handler-name-b,dom-handler-name-b"
                     */
                    if (storeRoutes) {

                        var attachEventHandlers = true; // Required in order to trigger events only once.

                        if (window.__domRoutes == undefined) {
                            window.__domRoutes = {};
                        } else {
                            attachEventHandlers = false;
                        }

                        $.extend(window.__domRoutes, routes);

                        if (attachEventHandlers) {

                            window.attachRequestDomHandlers = function () {
                                $("[data-request]:not('[request-dom-target-id]')").on('ajaxPromise', function (event, context) {
                                    context.options.data.__dom_target_id = Math.round(new Date().getTime() + (Math.random() * 100));
                                    $(this).attr('request-dom-target-id', context.options.data.__dom_target_id);
                                });
                            };

                            $(window).on('ajaxUpdateComplete', function (event, context, data, status, jqXHR) {
                                var handlers = [];
                                $.each(data, function (partial, content) {
                                    var selector = (context.options.update[partial]) ? context.options.update[partial] : partial;
                                    if (selector[0] == '#' || selector[0] == '.') {
                                        var $domTargetEl = $('[request-dom-target-id=' + context.options.data.__dom_target_id + ']:first'),
                                            $handlersEls = $('<div/>').html(content).contents().findClosest('[data-request-dom-handlers]');

                                        $handlersEls.each(function () {
                                            var elHandlers = $(this).data('request-dom-handlers').split(/\s+/);
                                            $.each(elHandlers, function () {
                                                if ($.inArray(this.toString(), handlers) < 0) {
                                                    handlers.push(this.toString());
                                                }
                                            })
                                        });

                                        if (handlers.length > 0) {
                                            var funcName;
                                            $.each(handlers, function () {
                                                funcName = this.toString().replace(/-/g, '_');
                                                if (funcName == '') return;
                                                if (window["__domRoutes"][funcName] == undefined) {
                                                    alert("No '" + funcName + "' dom handler was found.");
                                                } else {
                                                    window["__domRoutes"][funcName]($(selector), $domTargetEl);
                                                }
                                            });
                                            funcName = null;
                                        }
                                    }
                                    handlers = [];
                                });

                                window.attachRequestDomHandlers();
                            });

                            // On document ready, trigger any handlers if required, removing them afterwards
                            $(function () {
                                var handlers = [],
                                    executedHandlers = [];

                                $('[data-request-dom-handlers]').each(function () {
                                    var elHandlers = $(this).data('request-dom-handlers').split(/\s+/),
                                        $self = $(this);
                                    $.each(elHandlers, function () {
                                        if ($.inArray(this.toString(), handlers) < 0) {
                                            handlers.push(this.toString());
                                        }
                                    });

                                    if (handlers.length > 0) {
                                        var funcName;
                                        $.each(handlers, function () {
                                            if ($.inArray(this.toString(), executedHandlers) < 0) {
                                                funcName = this.toString().replace(/-/g, '_');
                                                if (window["__domRoutes"][funcName] == undefined) {
                                                    alert("No '" + funcName + "' dom handler was found.");
                                                } else {
                                                    window["__domRoutes"][funcName]($self, null);
                                                }
                                                executedHandlers.push(this.toString());
                                            }
                                        });
                                    }

                                    $(this).prop('data-request-dom-handlers', null);
                                });

                                handlers = executedHandlers = null;
                            });

                            window.attachRequestDomHandlers();
                        }
                        /**
                         * END OF CMS DOM ROUTER REQUEST POST EVENTS CALL HANDLERS
                         */
                    }

                    base.routes = routes;
                    $(document).ready(base.load);

                    base.executed = [];

                    base.element.watch('className', function (property, oldClasses, newClasses) {
                        var classes = newClasses.replace(/-/g, '_').split(/\s+/);

                        $.each(classes, function (i, className) {
                            if (!base.routeExecuted(className)) {
                                base.fire(className);
                                base.executed.push(className);
                            }
                        });
                    });
                };

                /**
                 * Checks if a route has been executed already
                 * @param  {string}    route        [description]
                 * @return {boolean}
                 */
                base.routeExecuted = function (route) {
                    return base.executed.indexOf(route) > -1;
                };

                /**
                 * Gets the classes on the body element
                 * @return {array}
                 */
                base.classes = function () {
                    return base.element.get(0).className.replace(/-/g, '_').split(/\s+/);
                };

                /**
                 * Load all events to be fired
                 * @return {void}
                 */
                base.load = function () {
                    base.fire('common');
                    $.each(base.classes(), function (i, className) {
                        base.fire(className);
                        base.executed.push(className);
                    });
                };

                /**
                 * Fire an event
                 * @param  {Function} func The function to be fired
                 * @param  {Array} args Arguments
                 * @return {Void}
                 */
                base.fire = function (func, args) {
                    var fire,
                        routes = base.routes;

                    fire = func !== '';
                    fire = fire && routes[func];
                    fire = fire && typeof routes[func] === 'function';

                    if (fire) {
                        routes[func](args);
                    }
                };

                // Run initializer
                base.init();

            },
            defaults: {
                element: 'body'
            }
        };
    }

    $.fn.router = function (routes, storeRoutes) {
        return this.each(function () {
            (new $.DOMRouter.router(this, routes, storeRoutes));
        });
    };

    if (typeof module !== 'undefined' && module.exports) {
        module.exports = $.DOMRouter.router;
    }

})(jQuery);
